import React from "react";
import TweetListItem from "./TweetListItem";
import {useSelector} from "react-redux";

const TweetList = () => {
  const tweets = useSelector((state) => state.tweets);
  return(
      <>
      <ul className="list-group">
        {
          tweets.map(tweet =>
              <TweetListItem tweet={tweet}/>
          )
        }
      </ul>
      </>
  )
};
export default TweetList;

